// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v7.34.1
// source: csat.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "csat";

/** Persisted CSAT configuration state (stored in snapshots) */
export interface CSATConfig {
  enabled: boolean;
  leadInMessage: string;
  surveyQuestion: string;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt?: Date | undefined;
  updatedBy?: string | undefined;
}

/** Command/Event message for updating CSAT configuration */
export interface CSATUpdateConfig {
  enabled?: boolean | undefined;
  leadInMessage?: string | undefined;
  surveyQuestion?: string | undefined;
}

function createBaseCSATConfig(): CSATConfig {
  return {
    enabled: false,
    leadInMessage: "",
    surveyQuestion: "",
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: undefined,
  };
}

export const CSATConfig: MessageFns<CSATConfig> = {
  encode(message: CSATConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    if (message.leadInMessage !== "") {
      writer.uint32(18).string(message.leadInMessage);
    }
    if (message.surveyQuestion !== "") {
      writer.uint32(26).string(message.surveyQuestion);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(42).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(58).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CSATConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCSATConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.leadInMessage = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.surveyQuestion = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CSATConfig {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      leadInMessage: isSet(object.leadInMessage)
        ? globalThis.String(object.leadInMessage)
        : isSet(object.lead_in_message)
        ? globalThis.String(object.lead_in_message)
        : "",
      surveyQuestion: isSet(object.surveyQuestion)
        ? globalThis.String(object.surveyQuestion)
        : isSet(object.survey_question)
        ? globalThis.String(object.survey_question)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
    };
  },

  toJSON(message: CSATConfig): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.leadInMessage !== "") {
      obj.leadInMessage = message.leadInMessage;
    }
    if (message.surveyQuestion !== "") {
      obj.surveyQuestion = message.surveyQuestion;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create(base?: DeepPartial<CSATConfig>): CSATConfig {
    return CSATConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CSATConfig>): CSATConfig {
    const message = createBaseCSATConfig();
    message.enabled = object.enabled ?? false;
    message.leadInMessage = object.leadInMessage ?? "";
    message.surveyQuestion = object.surveyQuestion ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    return message;
  },
};

function createBaseCSATUpdateConfig(): CSATUpdateConfig {
  return { enabled: undefined, leadInMessage: undefined, surveyQuestion: undefined };
}

export const CSATUpdateConfig: MessageFns<CSATUpdateConfig> = {
  encode(message: CSATUpdateConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== undefined) {
      writer.uint32(8).bool(message.enabled);
    }
    if (message.leadInMessage !== undefined) {
      writer.uint32(18).string(message.leadInMessage);
    }
    if (message.surveyQuestion !== undefined) {
      writer.uint32(26).string(message.surveyQuestion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CSATUpdateConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCSATUpdateConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.leadInMessage = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.surveyQuestion = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CSATUpdateConfig {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : undefined,
      leadInMessage: isSet(object.leadInMessage)
        ? globalThis.String(object.leadInMessage)
        : isSet(object.lead_in_message)
        ? globalThis.String(object.lead_in_message)
        : undefined,
      surveyQuestion: isSet(object.surveyQuestion)
        ? globalThis.String(object.surveyQuestion)
        : isSet(object.survey_question)
        ? globalThis.String(object.survey_question)
        : undefined,
    };
  },

  toJSON(message: CSATUpdateConfig): unknown {
    const obj: any = {};
    if (message.enabled !== undefined) {
      obj.enabled = message.enabled;
    }
    if (message.leadInMessage !== undefined) {
      obj.leadInMessage = message.leadInMessage;
    }
    if (message.surveyQuestion !== undefined) {
      obj.surveyQuestion = message.surveyQuestion;
    }
    return obj;
  },

  create(base?: DeepPartial<CSATUpdateConfig>): CSATUpdateConfig {
    return CSATUpdateConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CSATUpdateConfig>): CSATUpdateConfig {
    const message = createBaseCSATUpdateConfig();
    message.enabled = object.enabled ?? undefined;
    message.leadInMessage = object.leadInMessage ?? undefined;
    message.surveyQuestion = object.surveyQuestion ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
